(() => {
  let started = false;
  const events = ['pointerdown', 'keydown', 'scroll'];
  const start = () => {
    if (started) return;
    started = true;
    events.forEach((event) => window.removeEventListener(event, start));
    const script = document.createElement('script');
    script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    script.id = 'merchantWidgetScript';
    script.async = true;
    script.fetchPriority = 'low';
    script.onload = () => {
      const labelFrame = () => {
        const frame = document.getElementById('merchantwidgetiframe');
        if (!frame) return false;
        frame.title = document.documentElement.lang.startsWith('de')
          ? 'Google Kundenbewertungen für Dontix'
          : 'Google customer reviews for Dontix';
        return true;
      };
      const frameObserver = new MutationObserver(() => {
        if (labelFrame()) frameObserver.disconnect();
      });
      frameObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => frameObserver.disconnect(), 30000);
      window.merchantwidget.start({ position: 'LEFT_BOTTOM', sideMargin: 36, bottomMargin: 36, mobileSideMargin: 16, mobileBottomMargin: 46, merchant_id: '5653921708' });
      if (labelFrame()) frameObserver.disconnect();
    };
    document.head.appendChild(script);
  };
  const schedule = () => {
    events.forEach((event) => window.addEventListener(event, start, { once: true, passive: true }));
    if (!document.body.classList.contains('template-collection')) {
      setTimeout(() => {
        if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2000 });
        else start();
      }, 2500);
    }
  };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();

